import logoSvg from '../../static/images/simplea-logo-pl.svg';

export const Logo = () => {
    return <img src={logoSvg} alt="Simplea logo" className="logo" data-test="logo" />;
};
